// src/index.ts
var Permission = /* @__PURE__ */ ((Permission2) => {
  Permission2["MEMBERS_READ"] = "members:read";
  Permission2["MEMBERS_MANAGE"] = "members:manage";
  Permission2["BILLING_READ"] = "billing:read";
  Permission2["BILLING_MANAGE"] = "billing:manage";
  Permission2["FILES_READ"] = "files:read";
  Permission2["FILES_MANAGE"] = "files:manage";
  Permission2["AUDIT_READ"] = "audit:read";
  Permission2["SETTINGS_MANAGE"] = "settings:manage";
  return Permission2;
})(Permission || {});
var MemberRole = /* @__PURE__ */ ((MemberRole2) => {
  MemberRole2["OWNER"] = "owner";
  MemberRole2["ADMIN"] = "admin";
  MemberRole2["MEMBER"] = "member";
  return MemberRole2;
})(MemberRole || {});
var ROLE_PERMISSIONS = {
  ["owner" /* OWNER */]: new Set(Object.values(Permission)),
  ["admin" /* ADMIN */]: /* @__PURE__ */ new Set([
    "members:read" /* MEMBERS_READ */,
    "members:manage" /* MEMBERS_MANAGE */,
    "billing:read" /* BILLING_READ */,
    "files:read" /* FILES_READ */,
    "files:manage" /* FILES_MANAGE */,
    "audit:read" /* AUDIT_READ */,
    "settings:manage" /* SETTINGS_MANAGE */
  ]),
  ["member" /* MEMBER */]: /* @__PURE__ */ new Set(["members:read" /* MEMBERS_READ */, "files:read" /* FILES_READ */])
};
var NOTIFICATION_CHANNELS = ["email", "in_app", "push"];
var NOTIFICATION_TYPES = [
  "member_invited",
  "payment_failed",
  "subscription_expiring",
  "weekly_summary",
  "file_uploaded",
  // Sent by the virus scanner (backend/app/workers/jobs/virus_scan.py) since
  // T-102. It was missing from this list, so the settings page never offered
  // a row for it and the one notification type most worth muting or routing
  // to push had no controls at all.
  "file_infected",
  // T-321: an outbound-webhook endpoint auto-disabled after repeated failed
  // deliveries. Mirrors DEFAULT_PREFERENCES in
  // backend/app/modules/notifications/preferences.py, which
  // test_notification_preferences_mirror.py pins to this list.
  "webhook_endpoint_disabled"
];
var DEFAULT_NOTIFICATION_PREFERENCES = {
  member_invited: { email: true, in_app: true, push: false },
  payment_failed: { email: true, in_app: true, push: true },
  subscription_expiring: { email: true, in_app: true, push: false },
  weekly_summary: { email: true, in_app: false, push: false },
  file_uploaded: { email: false, in_app: true, push: false },
  file_infected: { email: true, in_app: true, push: true },
  webhook_endpoint_disabled: { email: true, in_app: true, push: false }
};
var REQUIRED_NOTIFICATION_CHANNELS = {
  payment_failed: ["email"],
  subscription_expiring: ["email"]
};
function isNotificationChannelRequired(type, channel) {
  return REQUIRED_NOTIFICATION_CHANNELS[type]?.includes(channel) ?? false;
}
export {
  DEFAULT_NOTIFICATION_PREFERENCES,
  MemberRole,
  NOTIFICATION_CHANNELS,
  NOTIFICATION_TYPES,
  Permission,
  REQUIRED_NOTIFICATION_CHANNELS,
  ROLE_PERMISSIONS,
  isNotificationChannelRequired
};
//# sourceMappingURL=index.js.map